<template>
    <a href="#" class="group inline-flex" v-on:click="sortColumn">
        <span class="p-auto m-auto">{{text}}</span>
        <!-- Active: "bg-gray-200 text-gray-900 group-hover:bg-gray-300", Not Active: "invisible text-gray-400 group-hover:visible group-focus:visible" -->
        <span class="ml-2 flex-none rounded text-gray-400"
              :class="{
                        'visible bg-gray-200 text-gray-900 group-hover:bg-gray-300': active,
                        'invisible text-gray-400 group-hover:visible group-focus:visible': !active
              }">
            <icon name="sort-down"
                  class="fill-gray-700 h-5 w-5 flex-none rounded text-gray-400"
                  :class="{'rotate-180': sortUp}"/>
        </span>
    </a>
</template>

<script>
import {SortDirections} from "@/mixins/SortDirections";
import Icon from "@/Shared/Icon";

export default {
    components: {
        Icon
    },
    props: {
        text: String,
        active: Boolean,
        sortDirection: String
    },
    mixins: [SortDirections],
    computed: {
        sortUp() {
            return this.sortDirection === SortDirections.data().ASCENDING;
        }
    },
    methods: {
        sortColumn() {
            let direction = this.sortDirection === SortDirections.data().ASCENDING ? SortDirections.data().DESCENDING : SortDirections.data().ASCENDING;
            this.$emit('sortColumn', direction);
        }
    }
}
</script>
